export const coverPoster = () => {
  $('.wp-block-cover video').each(function () {
    var poster = $(this).attr('poster');
    $(this)
      //.removeAttr('autoplay')
      .closest('.wp-block-cover')
      .css('background-image', 'url(' + poster + ')');

    // DELAY AUTOPLAY
    // $(this)
    //   .delay(2000)
    //   .queue(function () {
    //     $(this)[0].play();
    //     $(this).dequeue();
    //   });
  });
};
